import _ from "lodash";
import api from "CommonCore/api";
import {
  setupLookups,
} from "App/shk-form-tab";
import TR from "Common/translate";

const lookupNutzer = {
  type: "select",
  choices: lookup => _.map(lookup, l => ({ value: l.n_id, label: `${ l.n_vorname } ${ l.n_name }` })),
  inject: ["k_nutzerLookup"],
  selector: lookup => id => {
    if (lookup) {
      const n = lookup[id];
      return n && `${ n.n_vorname } ${ n.n_name }`;
    }
    return null;
  },
};
export const schema = {
  displayName: "Änderungsmitteilung",
  defaultSort: [{ field: "aem_mitgeteiltam", reverse: true }],
  toUserString: n => (`Mitteilung ${ n.aem_id }`),
  defaultFilters: [{ field: "aem_erledigtam", criteria: { empty: true } }],
  table: [
    {
      field: "aem_mitgeteiltam",
      display: "Mitgeteilt am",
      type: "date",
      sortable: true,
    },
    {
      field: "aem_nid",
      display: TR("Nutzer"),
      type: "date",
      sortable: true,
      lookup: { settings: lookupNutzer },
    },
    {
      field: "aem_erledigt_nid",
      display: "Erledigt von",
      sortable: true,
      lookup: { settings: lookupNutzer },
    },
    {
      field: "aem_erledigtam",
      display: "Erledigt am",
      type: "date",
      sortable: true,
    },
    {
      field: "art_kbez",
      display: "Vertragsart",
      sortable: true,
    },
    {
      field: "e_kbez",
      display: "Fakultät/ZE",
      sortable: true,
    },

  ],
};

setupLookups(schema);

const desc = {
  id: "aem_id",
  name: "aenderungsmitteilung",
  endpoint: "/api/shkantrag/aenderung/mitteilung",
  schema,
  breadcrumbs: {
    list: "Änderungsmitteilung",
    detail: n => schema.toUserString(n),
  },
};

const aenderungsmitteilungApi = api(desc);
export default aenderungsmitteilungApi;

